/* eslint-disable react/no-danger */
import { Breadcrumb } from "@components/anti/Breadcrumb"
import SectionFullSlider from "@components/global/SectionFullSlider"
import { linkNewsroom } from "src/helper/page-url"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import {
  convertHtmlToReact,
  convertJson,
  extractMeta,
  imgUrl,
} from "src/mixins"

function NewsroomDetail({ data, locale }) {
  const [trigger, anim] = useScrollAnim("fadeInUp", 0.1)
  const slideShow = extractMeta(data?.meta, "slideshow")
  const slideShowItems = convertJson(slideShow?.items)?.length
    ? convertJson(slideShow.items)
    : [{ image: data?.featured_image }]
  return (
    <section className="sc-newsroom-detail">
      <div className="container">
        <Breadcrumb
          path={[
            {
              title: translations[`newsroom_${locale}`],
              url: linkNewsroom,
            },
            {
              title: data[`title_${locale}`],
            },
          ]}
        />
      </div>
      <div className="py-5">
        <div className="container mw-lg">
          <SectionFullSlider
            imgHeight="h-auto h-md-600px"
            sectionName="sc-newsroom-detail__cover"
            data={slideShowItems?.map((item) => ({
              title: "",
              text: "",
              img: imgUrl(item?.image),
              imgMd: imgUrl(item?.image),
            }))}
          />
          <div ref={trigger}>
            {/* <p className={`sc-newsroom-detail__tags ${anim(1)}`}>
              {data?.categories?.length &&
                data?.categories[0][`title_${locale}`]}{" "}
              | {formatDate(data?.published_at)}
            </p> */}
            <h1 className={`title mb-4 ${anim(2)}`}>
              {data && data[`title_${locale}`]}
            </h1>
            <div className={`sc-newsroom-detail__content ${anim(3)}`}>
              {convertHtmlToReact(data[`content_${locale}`])}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NewsroomDetail
